import { defineStore } from 'pinia';
import { mande } from 'mande';

import { auth0 } from '../auth0.js';
import { fetchWithTimeoutAndCache, loadCache, saveCacheArray } from '@/utils/cacheUtils.js';

export const initApi = async () => {
  const token = await auth0.getAccessTokenSilently();

  return mande(`${import.meta.env.VITE_APP_API_URL}/accounts`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const useStore = defineStore('account', {
  state: (): { accounts: ETNAccount[] } => {
    return {
      accounts: []
    };
  },
  actions: {
    async listAccounts() {
      try {
        const fetchFn = async () => {
          const api = await initApi();
          const response = (await api.get({
            query: {
              type: 'electricity,gas,water,heating,cooling',
              $multi: true,
              $limit: 1000000,
              $select:
                'meterSerialNumber,meterPointNumber,name,type,meterLocation,parentAccountId,registerIds,assetId,entityId,companyId,meterUnits,factor,automaticMeterRead,meterUser'
            }
          })) as ETNAPIResponse;
          return response.data as ETNAccount[];
        };

        const cacheFn = () => loadCache<ETNAccount>('accounts');

        const { data: accounts, fromCache } = await fetchWithTimeoutAndCache(fetchFn, cacheFn);

        this.accounts = accounts;

        if (!fromCache) {
          await saveCacheArray('accounts', accounts);
        }
        return this.accounts;
      } catch (e) {
        console.error('Failed to load accounts', e);
        this.accounts = [];
        return [];
      }
    }
  },
  getters: {
    getAccountById:
      (state) =>
      (accountId: string): ETNAccount | undefined => {
        return state.accounts.find((account) => account._id === accountId);
      },
    accountsByAssetId:
      (state) =>
      (assetId: string): ETNAccount[] => {
        return state.accounts.filter((account) => account.assetId === assetId);
      }
  }
});
